<template>
  <div class="div">
    <div class="text">
      <div class="img"></div>
      <span>五城各平台运力分布</span>
    </div>
    <div class="carry">
      <div class="carrying1">
        <div class="myChart1" ref="myChart1" :style="{ width: '120px', height: '120px' }"></div>
        <span class="name">{{chartObjLeft3.dataNameList[0]}}</span>
        <div class="myChart1text">
          <div class="text1">{{ value1 }}</div>
          <span class="text2">个</span>
        </div>
      </div>
      <div class="carrying2">
        <div class="myChart2" ref="myChart2" :style="{ width: '120px', height: '120px' }"></div>
        <span class="name">{{chartObjLeft3.dataNameList[1]}}</span>
        <div class="myChart1text">
          <div class="text1">{{ value2 }}</div>
          <span class="text2">个</span>
        </div>
      </div>
      <div class="carrying3">
        <div class="myChart3" ref="myChart3" :style="{ width: '120px', height: '120px' }"></div>
        <span class="name">{{chartObjLeft3.dataNameList[2]}}</span>
        <div class="myChart1text">
          <div class="text1">{{ value3 }}</div>
          <span class="text2">个</span>
        </div>
      </div>
      <div class="carrying4">
        <div class="myChart4" ref="myChart4" :style="{ width: '120px', height: '120px' }"></div>
        <span class="name">{{chartObjLeft3.dataNameList[3]}}</span>
        <div class="myChart1text">
          <div class="text1">{{ value4 }}</div>
           <!-- <div class="text1">0</div> -->
          <span class="text2">个</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var mychart1 = null;
var mychart2 = null;
var mychart3 = null;
var mychart4 = null;
var option1 = {
  title: {
    text: 45 + "%",
    x: "center",
    y: "center",
    textStyle: {
      fontSize: 20,
      color: "#29EEF3",
      fontWeight: "100"
    }
  },
  series: [
    {
      type: "pie",
      radius: ["68%", "55%"],
      silent: true,
      clockwise: true,
      startAngle: 90,
      z: 0,
      zlevel: 0,
      label: {
        normal: {
          position: "center"
        }
      },
      data: [
        {
          value: 45,
          name: "",
          itemStyle: {
            normal: {
              color: {
                // 完成的圆环的颜色
                colorStops: [
                  {
                    offset: 0,
                    color: "#8a8c8e" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#ffe600" // 100% 处的颜色
                  }
                ]
              }
            }
          }
        },
        {
          value: 100 - 45,
          name: "",
          label: {
            normal: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              color: "#173164"
            }
          }
        }
      ]
    },
    {
      name: "",
      type: "gauge",
      radius: "68%",
      center: ["50%", "50%"],
      startAngle: 0,
      endAngle: 359.9,
      splitNumber: 40,
      hoverAnimation: true,
      axisTick: {
        show: false
      },
      splitLine: {
        length: 8,
        lineStyle: {
          width: 1,
          color: "#061740"
        }
      },
      axisLabel: {
        show: false
      },
      pointer: {
        show: false
      },
      axisLine: {
        lineStyle: {
          opacity: 0
        }
      },
      detail: {
        show: false
      },
      data: [
        {
          value: 0,
          name: ""
        }
      ]
    }
  ]
};
var option2 = {
  title: {
    text: 45 + "%",
    x: "center",
    y: "center",
    textStyle: {
      fontSize: 20,
      color: "#29EEF3",
      fontWeight: "100"
    }
  },
  series: [
    {
      type: "pie",
      radius: ["68%", "55%"],
      silent: true,
      clockwise: true,
      startAngle: 90,
      z: 0,
      zlevel: 0,
      label: {
        normal: {
          position: "center"
        }
      },
      data: [
        {
          value: 45,
          name: "",
          itemStyle: {
            normal: {
              color: {
                // 完成的圆环的颜色
                colorStops: [
                  {
                    offset: 0,
                    color: "#8a8c8e" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#00ae9d" // 100% 处的颜色
                  }
                ]
              }
            }
          }
        },
        {
          value: 100 - 45,
          name: "",
          label: {
            normal: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              color: "#173164"
            }
          }
        }
      ]
    },
    {
      name: "",
      type: "gauge",
      radius: "68%",
      center: ["50%", "50%"],
      startAngle: 0,
      endAngle: 359.9,
      splitNumber: 40,
      hoverAnimation: true,
      axisTick: {
        show: false
      },
      splitLine: {
        length: 8,
        lineStyle: {
          width: 1,
          color: "#061740"
        }
      },
      axisLabel: {
        show: false
      },
      pointer: {
        show: false
      },
      axisLine: {
        lineStyle: {
          opacity: 0
        }
      },
      detail: {
        show: false
      },
      data: [
        {
          value: 0,
          name: ""
        }
      ]
    }
  ]
};
var option3 = {
  title: {
    text: 45 + "%",
    x: "center",
    y: "center",
    textStyle: {
      fontSize: 20,
      color: "#29EEF3",
      fontWeight: "100"
    }
  },
  series: [
    {
      type: "pie",
      radius: ["68%", "55%"],
      silent: true,
      clockwise: true,
      startAngle: 90,
      z: 0,
      zlevel: 0,
      label: {
        normal: {
          position: "center"
        }
      },
      data: [
        {
          value: 45,
          name: "",
          itemStyle: {
            normal: {
              color: {
                // 完成的圆环的颜色
                colorStops: [
                  {
                    offset: 0,
                    color: "#8a8c8e" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#28E8FA" // 100% 处的颜色
                  }
                ]
              }
            }
          }
        },
        {
          value: 100 - 45,
          name: "",
          label: {
            normal: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              color: "#173164"
            }
          }
        }
      ]
    },
    {
      name: "",
      type: "gauge",
      radius: "68%",
      center: ["50%", "50%"],
      startAngle: 0,
      endAngle: 359.9,
      splitNumber: 40,
      hoverAnimation: true,
      axisTick: {
        show: false
      },
      splitLine: {
        length: 8,
        lineStyle: {
          width: 1,
          color: "#061740"
        }
      },
      axisLabel: {
        show: false
      },
      pointer: {
        show: false
      },
      axisLine: {
        lineStyle: {
          opacity: 0
        }
      },
      detail: {
        show: false
      },
      data: [
        {
          value: 0,
          name: ""
        }
      ]
    }
  ]
}
var option4 = {
  title: {
    text: 45 + "%",
    x: "center",
    y: "center",
    textStyle: {
      fontSize: 20,
      color: "#29EEF3",
      fontWeight: "100"
    }
  },
  series: [
    {
      type: "pie",
      radius: ["68%", "55%"],
      silent: true,
      clockwise: true,
      startAngle: 90,
      z: 0,
      zlevel: 0,
      label: {
        normal: {
          position: "center"
        }
      },
      data: [
        {
          value: 45,
          name: "",
          itemStyle: {
            normal: {
              color: {
                // 完成的圆环的颜色
                colorStops: [
                  {
                    offset: 0,
                    color: "#8a8c8e" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#f15a22" // 100% 处的颜色
                  }
                ]
              }
            }
          }
        },
        {
          value: 100 - 45,
          name: "",
          label: {
            normal: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              color: "#173164"
            }
          }
        }
      ]
    },
    {
      name: "",
      type: "gauge",
      radius: "68%",
      center: ["50%", "50%"],
      startAngle: 0,
      endAngle: 359.9,
      splitNumber: 40,
      hoverAnimation: true,
      axisTick: {
        show: false
      },
      splitLine: {
        length: 8,
        lineStyle: {
          width: 1,
          color: "#061740"
        }
      },
      axisLabel: {
        show: false
      },
      pointer: {
        show: false
      },
      axisLine: {
        lineStyle: {
          opacity: 0
        }
      },
      detail: {
        show: false
      },
      data: [
        {
          value: 0,
          name: ""
        }
      ]
    }
  ]
}
export default {
  props: {
    chartObjLeft3: {
      type: Object,
      default: function () {
        return {
          dataList: [],
          dataNameList: []
        };
      }
    }
  },
  watch: {
    chartObjLeft3: {
      handler (data) {
        this.carryingChart(data.dataList);
      },
      deep: true
    }
  },
  data () {
    return {
      value1: 1000,
      value2: 1000,
      value3: 1000,
      value4: 1000,
    };
  },

  mounted () {
    this.mychart1 = this.$echarts.init(this.$refs.myChart1);
    this.mychart2 = this.$echarts.init(this.$refs.myChart2);
    this.mychart3 = this.$echarts.init(this.$refs.myChart3);
    this.mychart4 = this.$echarts.init(this.$refs.myChart4);
    this.CarryIng();
  },
  methods: {
    CarryIng () {
      let angle = 0;
      option1.series.push(
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.8,
                startAngle: ((0 + angle) * Math.PI) / 180,
                endAngle: ((90 + angle) * Math.PI) / 180
              },
              style: {
                stroke: "#ffe600",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.8,
                startAngle: ((180 + angle) * Math.PI) / 180,
                endAngle: ((270 + angle) * Math.PI) / 180
              },
              style: {
                stroke: "#ffe600	",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.9,
                startAngle: ((270 + -angle) * Math.PI) / 180,
                endAngle: ((40 + -angle) * Math.PI) / 180
              },
              style: {
                stroke: "ffe600	",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.9,
                startAngle: ((90 + -angle) * Math.PI) / 180,
                endAngle: ((220 + -angle) * Math.PI) / 180
              },
              style: {
                stroke: "ffe600	",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        }
      );
      option2.series.push(
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.8,
                startAngle: ((0 + angle) * Math.PI) / 180,
                endAngle: ((90 + angle) * Math.PI) / 180
              },
              style: {
                stroke: "#00ae9d",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.8,
                startAngle: ((180 + angle) * Math.PI) / 180,
                endAngle: ((270 + angle) * Math.PI) / 180
              },
              style: {
                stroke: "#00ae9d",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.9,
                startAngle: ((270 + -angle) * Math.PI) / 180,
                endAngle: ((40 + -angle) * Math.PI) / 180
              },
              style: {
                stroke: "#00ae9d",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.9,
                startAngle: ((90 + -angle) * Math.PI) / 180,
                endAngle: ((220 + -angle) * Math.PI) / 180
              },
              style: {
                stroke: "#00ae9d",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        }
      );
      option3.series.push(
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.8,
                startAngle: ((0 + angle) * Math.PI) / 180,
                endAngle: ((90 + angle) * Math.PI) / 180
              },
              style: {
                stroke: "#0CD3DB",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.8,
                startAngle: ((180 + angle) * Math.PI) / 180,
                endAngle: ((270 + angle) * Math.PI) / 180
              },
              style: {
                stroke: "#0CD3DB",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.9,
                startAngle: ((270 + -angle) * Math.PI) / 180,
                endAngle: ((40 + -angle) * Math.PI) / 180
              },
              style: {
                stroke: "#0CD3DB",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.9,
                startAngle: ((90 + -angle) * Math.PI) / 180,
                endAngle: ((220 + -angle) * Math.PI) / 180
              },
              style: {
                stroke: "#0CD3DB",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        }
      );
      option4.series.push(
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.8,
                startAngle: ((0 + angle) * Math.PI) / 180,
                endAngle: ((90 + angle) * Math.PI) / 180
              },
              style: {
                stroke: "#f15a22",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.8,
                startAngle: ((180 + angle) * Math.PI) / 180,
                endAngle: ((270 + angle) * Math.PI) / 180
              },
              style: {
                stroke: "#f15a22",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.9,
                startAngle: ((270 + -angle) * Math.PI) / 180,
                endAngle: ((40 + -angle) * Math.PI) / 180
              },
              style: {
                stroke: "#f15a22",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        },
        {
          name: "ring5",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.9,
                startAngle: ((90 + -angle) * Math.PI) / 180,
                endAngle: ((220 + -angle) * Math.PI) / 180
              },
              style: {
                stroke: "#f15a22",
                fill: "transparent",
                lineWidth: 1
              },
              silent: true
            };
          },
          data: [0]
        }
      );
      //获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)
      function getCirlPoint (x0, y0, r, angle) {
        let x1 = x0 + r * Math.cos((angle * Math.PI) / 180);
        let y1 = y0 + r * Math.sin((angle * Math.PI) / 180);
        return {
          x: x1,
          y: y1
        };
      }
      var draw = () => {
        angle = angle + 3;
        this.mychart1.setOption(option1);
        this.mychart2.setOption(option2);
        this.mychart3.setOption(option3);
        this.mychart4.setOption(option4);
        //window.requestAnimationFrame(draw);
      };
      setInterval(function () {
        //用setInterval做动画感觉有问题
        draw();
      }, 100);
    },
    carryingChart (dataList) {
      //处理auv的数据
      let dataZong = dataList[0] + dataList[1] + dataList[2] + dataList[3]
      let List1 = ((dataList[0] / dataZong) * 100).toFixed(0);
      // console.log(List1);
      let text1 = List1 + "%"; //处理仪表盘内数字
      this.value1 = dataList[0]; //文字显示
      option1.title.text = text1;
      option1.series[0].data[0].value = List1;
      option1.series[0].data[1].value = 100 - List1;
      //处理跃云的数据
      let List2 = ((dataList[1] / dataZong) * 100).toFixed(0);
      let text2 = List2 + "%"; //处理仪表盘内数字
      this.value2 = dataList[1]; //文字显示
      option2.title.text = text2;
      option2.series[0].data[0].value = List2;
      option2.series[0].data[1].value = 100 - List2;

      // 处理有车速报数据
      let List3 = ((dataList[2] / dataZong) * 100).toFixed(0);
      let text3 = List3 + "%";
      this.value3 = dataList[2];
      option3.title.text = text3;
      option3.series[0].data[0].value = List3;
      option3.series[0].data[1].value = 100 - List3;

      //处理旭阳数据
      let List4 = ((dataList[3] / dataZong) * 100).toFixed(0);
      let text4 = List4 + "%";
      this.value4 = dataList[3];
      option4.title.text = text4;
      option4.series[0].data[0].value = List4;
      option4.series[0].data[1].value = 100 - List4;
      // 数据渲染
      this.mychart1.setOption(option1);
      this.mychart2.setOption(option2);
      this.mychart3.setOption(option3);
      this.mychart4.setOption(option4);
    }
  }
};
</script>

<style scoped>
.div {
  margin: 0 auto;
  width: 100%;
  height: 400px;
  background-image: url('../assets/img/carrying/左3bg.png');
  background-size: 100% 100%;
}
.div .text {
  width: 94%;
  height: 10%;
  display: flex;
  margin: 0 3%;
  padding-top: 5%;
  background-image: url('../assets/img/carrying/左3line.png');
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 95%;
  position: relative;
}
.div .text .img {
  width: 40px;
  height: 40px;
  margin: 0;
  position: absolute;
  top: 24px;
  left: -5px;
  background-image: url('../assets/img/carrying/icon.png');
  background-repeat: no-repeat;
  background-size: 110%;
}
.div .text span {
  color: aliceblue;
  padding-top: 13px;
  padding-left: 32px;
  font-family: 'PingFangSC-Regular';
  font-size: 18px;
}
.div .carry {
  clear: both;
  width: 100%;
  height: 100%;
}
.div .carry .carrying1 {
  position: relative;
  float: left;
  width: 50%;
  height: 40%;
  background-image: url('../assets/img/carrying/2.png');
  background-repeat: no-repeat;
  background-position: 70% 65%;
  background-size: 60%;
}
.div .carry .carrying1 .myChart1 {
  margin-top: 12%;
  margin-left: 3%;
}
.div .carry .carrying1 .name,
.div .carry .carrying2 .name,
.div .carry .carrying4 .name {
  color: aliceblue;
  font-size: 15px;
  position: absolute;
  top: 28%;
  right: 24%;
}
.div .carry .carrying1 .myChart1text,
.div .carry .carrying2 .myChart1text,
.div .carry .carrying3 .myChart1text,
.div .carry .carrying4 .myChart1text {
  display: flex;
  width: 40%;
  height: 21%;
  margin-top: 7%;
  position: absolute;
  top: 50%;
  right: 15%;
  color: aliceblue;
}
.div .carry .carrying1 .myChart1text .text1,
.div .carry .carrying2 .myChart1text .text1 {
  margin-left: 18%;
  font-size: 20px;
  font-family: 'DIN Alternate';
}
.div .carry .carrying4 .myChart1text .text1,
.div .carry .carrying3 .myChart1text .text1 {
  margin-left: 30%;
  font-size: 20px;
  font-family: 'DIN Alternate';
}
.div .carry .carrying1 .myChart1text .text2,
.div .carry .carrying2 .myChart1text .text2,
.div .carry .carrying3 .myChart1text .text2,
.div .carry .carrying4 .myChart1text .text2 {
  padding-left: 5%;
  padding-top: 5%;
  font-size: 14px;
  color: rgb(143, 143, 143);
}
.div .carry .carrying2 {
  position: relative;
  float: left;
  width: 50%;
  height: 40%;
  background-image: url('../assets/img/carrying/1.png');
  background-repeat: no-repeat;
  background-position: 70% 65%;
  background-size: 60%;
}
.div .carry .carrying2 .myChart2 {
  margin-top: 12%;
  margin-left: 3%;
}
.div .carry .carrying3 {
  position: relative;
  float: left;
  width: 50%;
  height: 40%;
  background-image: url('../assets/img/carrying/4.png');
  background-repeat: no-repeat;
  background-position: 70% 65%;
  background-size: 60%;
}

.div .carry .carrying3 .name {
  color: aliceblue;
  font-size: 15px;
  position: absolute;
  top: 28%;
  right: 15%;
}
.div .carry .carrying3 .myChart3 {
  margin-top: 12%;
  margin-left: 3%;
}
.div .carry .carrying4 {
  position: relative;
  float: left;
  width: 50%;
  height: 40%;
  background-image: url('../assets/img/carrying/3.png');
  background-repeat: no-repeat;
  background-position: 70% 65%;
  background-size: 60%;
}
.div .carry .carrying4 .myChart4 {
  margin-top: 12%;
  margin-left: 3%;
}
</style>



// WEBPACK FOOTER //
// src/components/Carrying.vue